
<script>
  import { Line , mixins } from "vue-chartjs";
  export default {
    mixins: [mixins.reactiveData, mixins.reactiveProp],
    extends: Line,
    props: {
      chartData: {
        type: Array | Object,
        required: false
      },
      chartLabels: {
        type: Array,
        required: true
      },
      chartDetail: {
        type: Array | Object,
        required: false
      },
    },
    data () {
      return {
        options: {
          scales: {
            yAxes: [{
              ticks: {
                 beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false
              }
            }]
          },
           tooltips: {
            backgroundColor: '#4F5565',
            titleFontStyle: 'normal',
            titleFontSize: 18,
            bodyFontFamily: "'Proxima Nova', sans-serif",
            cornerRadius: 3,
            bodyFontColor: '#20C4C8',
            bodyFontSize: 14,
            xPadding: 14,
            yPadding: 14,
            displayColors: false,
            mode: 'index',
            intersect: false,
            callbacks: {
             // title: tooltipItem => {
             //   return `🗓 ${tooltipItem[0].xLabel}`
             // },
              label: (tooltipItem, data) => {
                //debugger;
                let dataset = data.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                let valorDetalle = this.chartDetail[tooltipItem.index]
                return `${valorDetalle.precioOferta}` + ` - ` +`${valorDetalle.razonSocial}`
              }
            }
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      this.renderChart({
        labels: this.chartLabels,
        datasets: [
          {
            label: 'precios',
            borderColor: '#249EBF',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF',
            backgroundColor: 'transparent',
            data: this.chartData
          }
        ]
      }, this.options)
    },
     watch: {
    data: function() {
      this._chart.destroy();
      //this.renderChart(this.data, this.options);
       this.renderChart({
        labels: this.chartLabels,
        datasets: [
          {
            label: 'precios',
            borderColor: '#249EBF',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#249EBF',
            backgroundColor: 'transparent',
            data: this.chartData
          }
        ]
      }, this.options)
    }
  }
  }
</script>
 